"use client";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check } from 'lucide-react';
import { classNames } from '../utils/classNames';
import useCopyClipboard from '../../hooks/useCopyClipboard';
import { useState } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../shadcn/tooltip';
import CopyIcon from '../Icons/CopyIcon';
const CopyButton = ({ className, toCopy, children, iconSize, iconClassName, disabled = false, }) => {
    const [isCopied, setCopied] = useCopyClipboard();
    const [isTooltipOpen, setTooltipOpen] = useState(false);
    const handleCopyClick = () => {
        if (disabled)
            return;
        setCopied(toCopy);
        setTooltipOpen(true);
    };
    return (_jsxs(Tooltip, { open: isTooltipOpen, onOpenChange: setTooltipOpen, children: [_jsx(TooltipTrigger, { children: _jsx("div", { className: classNames(className, "flex items-center gap-1", "cursor-pointer", disabled && "opacity-50 cursor-not-allowed pointer-events-none"), onClick: handleCopyClick, tabIndex: disabled ? -1 : 0, "aria-disabled": disabled, children: isCopied ? (_jsxs(_Fragment, { children: [_jsx(Check, { className: iconClassName, width: iconSize ? iconSize : 16, height: iconSize ? iconSize : 16 }), children] })) : (_jsxs(_Fragment, { children: [_jsx(CopyIcon, { className: iconClassName, width: iconSize ? iconSize : 16, height: iconSize ? iconSize : 16 }), children] })) }) }), _jsx(TooltipContent, { children: _jsx("p", { children: isCopied ? "Copied" : "Copy" }) })] }));
};
export default CopyButton;
